import { Pipe , PipeTransform } from '@angular/core'

@Pipe({
		name: 'formatDistance'
})
export class FormatDistance implements PipeTransform {
		public transform(distance: number): string {
				const distanceFormated = distance / 1000

				return distanceFormated.toFixed(1)
		}
}
